const AXIS = {
    tickSize: 0,
    size: '0.75rem',
    style: 'italic',
    color: '#b5b5b5',
}

const axisLabelStyle = {
    title: {
        fontSize: AXIS.size, 
        fontStyle: AXIS.style
    }, 
    line: {
        stroke: AXIS.color
    }, 
    text: {
        display: 'none'
    }
}

export const axisConfig = (xLabel: string, yLabel: string, xZero: boolean = false, yZero: boolean = false) => ({
    xAxis: {
        on0: xZero,
        tickSize: AXIS.tickSize,
        title: xLabel,
        style: axisLabelStyle
    },
    yAxis: {
        on0: yZero,
        tickSize: AXIS.tickSize,
        title: yLabel,
        style: axisLabelStyle
    }
})


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/config/AxisConfig.tsx